import React from 'react';

import { Grid, DescriptionItem } from '@gogame/components';

import {
  ConceptDetailsGeneral,
  ConceptDetailsInfo,
} from 'scenes/Gallery/GalleryPage/Concepts/ConceptDetails';
import * as CONCEPT from 'scenes/Gallery/GalleryPage/Concepts/view-constants';
import { AttributeItem } from 'scenes/Gallery/components/AttributeList';
import TrackerLink from 'scenes/Gallery/components/TrackerLink';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';
import { DIMENSION_CONCEPT } from 'scenes/Trackers/Tracker/constants';

const Details = ({ data, openChildComponent }) => {
  const { isAllowPerformance } = useGalleryPermissions();

  const { [CONCEPT.ID]: conceptId, [CONCEPT.HAS_STATS]: hasStats } = data;

  return (
    <Grid container spacing={3} p={2}>
      <Grid item xs={6}>
        <ConceptDetailsGeneral
          data={data}
          withNameField={false}
          openChildComponent={openChildComponent}
          termWidth={'140px'}
          fieldAds={
            <DescriptionItem
              label={'Ads'}
              value={(hasStats && isAllowPerformance) || null}
              type={() => (
                <TrackerLink dimension={DIMENSION_CONCEPT} id={conceptId}>
                  <AttributeItem
                    type={'label'}
                    valueParser={'ads'}
                    clickable={true}
                    underline={'always'}
                  />
                </TrackerLink>
              )}
            />
          }
        />
      </Grid>
      <Grid item xs={6}>
        <ConceptDetailsInfo
          data={data}
          openChildComponent={openChildComponent}
          termWidth={'140px'}
        />
      </Grid>
    </Grid>
  );
};

export default Details;
